import $ from 'jquery';
import { runProtectedRoute } from '../middleware';
import ReactDOM from 'react-dom';
import React from 'react';
import { Removebg } from '~src/components/Removebg';
import { showNavbarPrivateBackButton } from '~src/utils';
import { trackPageView } from '~src/tracking';

export const removebgRoute = async () => {
  document.title = 'Crediti IA | Giotto';
  const ready = await runProtectedRoute();
  if (!ready) return;

  showNavbarPrivateBackButton();
  $('#route-removebg').show();
  const domContainer = document.querySelector('#route-removebg');
  ReactDOM.render(React.createElement(Removebg), domContainer);
  trackPageView('Credits');
};
